export default function truncateText(text: string, numberOfChar: number): string {
    if (text.length > numberOfChar) {
        return text.slice(0, numberOfChar - 3) + "...";
    }
    return text;
}
